var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 92 92"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE1D52",
    fillRule: "evenodd",
    d: "M55.55 39.428a18.008 18.008 0 0 0 10.5 3.331v-7.457a10.1 10.1 0 0 1-2.2-.236v5.94a17.996 17.996 0 0 1-10.513-3.367v15.336a13.944 13.944 0 0 1-21.65 11.57 13.943 13.943 0 0 0 23.862-9.743V39.429Zm2.72-7.605a10.426 10.426 0 0 1-2.72-6.14v-.97H53.46a10.539 10.539 0 0 0 4.81 7.11ZM36.523 58.642a6.362 6.362 0 0 1 5.108-10.228c.657 0 1.311.1 1.939.298v-7.705a14.674 14.674 0 0 0-2.213-.124v5.99a6.375 6.375 0 0 0-4.797 11.769h-.037Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M53.336 37.59a17.996 17.996 0 0 0 10.514 3.367v-5.94a10.489 10.489 0 0 1-5.58-3.194 10.54 10.54 0 0 1-4.81-7.11h-5.493v30.089a6.375 6.375 0 0 1-11.446 3.84 6.375 6.375 0 0 1 4.797-11.77v-5.99a13.931 13.931 0 0 0-9.632 23.663 13.945 13.945 0 0 0 21.687-11.57l-.037-15.386Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#69C9D0",
    fillRule: "evenodd",
    d: "M63.85 35.016v-1.603a10.427 10.427 0 0 1-5.58-1.59 10.403 10.403 0 0 0 5.58 3.193ZM53.46 24.713c0-.286-.086-.584-.123-.87v-.969h-7.582v30.1a6.363 6.363 0 0 1-6.375 6.339 6.289 6.289 0 0 1-2.858-.672 6.376 6.376 0 0 0 11.446-3.84V24.713h5.493ZM41.32 40.87v-1.703a13.932 13.932 0 0 0-9.632 25.378 13.932 13.932 0 0 1 9.669-23.613l-.037-.062Z",
    clipRule: "evenodd"
  })));
};
export default SvgTiktok;